"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate = function (date) {
    var year = date.getFullYear(); // Get the full year
    var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, add 1 and pad to 2 digits
    var day = String(date.getDate()).padStart(2, '0'); // Pad day to 2 digits
    var hour = String(date.getHours()).padStart(2, '0'); // Pad hour to 2 digits
    return year + "-" + month + "-" + day + " " + hour;
};
var DataSet = /** @class */ (function () {
    function DataSet(name, colour) {
        this.data = [];
        this.name = name;
        this.colour = colour;
    }
    DataSet.prototype.add = function (point) {
        this.data.push(point);
    };
    DataSet.prototype.clear = function () {
        this.data = [];
    };
    DataSet.prototype.toGraph = function (ctx) {
        var gradientStroke = {};
        if (ctx) {
            var stroke = ctx.createLinearGradient(0, 0, 0, 450);
            stroke.addColorStop(0, 'rgba(85, 189, 213, 1)');
            stroke.addColorStop(0.25, 'rgba(85, 189, 213, 0.5)');
            stroke.addColorStop(0.5, 'rgba(85, 189, 213, 0.25)');
            gradientStroke = stroke;
        }
        return {
            label: this.name.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }),
            borderColor: gradientStroke,
            pointBackgroundColor: this.colour,
            backgroundColor: gradientStroke,
            data: this.data.map(function (data) { return data.toGraph(); }),
            pointRadius: 3,
        };
    };
    DataSet.prototype.labels = function () {
        return this.data.map(function (data) { return formatDate(data.x); });
    };
    return DataSet;
}());
exports.default = DataSet;
